export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manargw.10e26c92.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};